import { css } from '@microsoft/fast-element';
import { mixinCardTitle } from './typography';

export const stylesCardHeading = css`
  header h1 {
    ${mixinCardTitle}
  }
`;

export const boxSizing = `
  :host, :host *, :host ::after, :host ::before { box-sizing:border-box }
`;

export const mixinScreen = (display: string = 'block') => `
  contain: content;
  display: ${display};
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

export const mixinCardStyles = `
  padding: calc(var(--design-unit) * 2px);
`;

/**
 * Temp as these parts are being removed from foundation-ui
 */
export const hideZeroButtonParts = `
  zero-button::part(info1),
  zero-button::part(info2) {
    display: none;
  }
`;

export const scrollbarStyles = `
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 4px var(--top-level-tab-font);
    background: var(--neutral-layer-2);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--top-level-tab-font);
    border-radius: 10px;
  }
`;

export const pageContainerStyles = `
  display: flex;  
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height:100%;
  padding: 16px;
  color: rgb(204, 204, 204);
  font-size: var(--font-size_13px);
`;
